import { createContext } from 'react';
import { ChannelType } from '../../../gql/generated';

export interface ChannelFormData {
  name: string;
  channelType: ChannelType;
  isActive: boolean;

  // Email-specific fields
  email?: string;

  // Teams-specific fields
  teamsWebhookUrl?: string;

  // Grouped-specific fields
  groupedChannelIds?: string[];
}

export interface AddChannelDialogContextValue {
  formData: ChannelFormData;
  setFormData: (data: ChannelFormData) => void;
  updateFormData: (updates: Partial<ChannelFormData>) => void;
}

export const AddChannelDialogContext = createContext<
  AddChannelDialogContextValue | undefined
>(undefined);
